import React, { FC } from 'react';
import Modal from '@components/Modal';
import { Creditor } from '@/typings/api-models';
import CreateEditCreditorForm from '@/lib/CreateEditCreditorForm';

type Props = {
  creditor: Creditor | null;
  onClose: () => void;
  onSubmit: (creditorId: string | null) => Promise<void>;
};

const CreateEditCreditorModal: FC<Props> = ({ onSubmit, creditor, onClose }) => (
  <Modal title={creditor ? 'Edit Creditor' : 'Create Creditor'} onClose={onClose} >
    <CreateEditCreditorForm creditor={creditor} onSubmit={onSubmit}/>
  </Modal>
);

export default CreateEditCreditorModal;
